// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2kbRP","content":"styles_content__2Opz6","selectAll":"styles_selectAll__3WqxL"};